<template>
  <div class="northwestern" redesign>
    <!-- Header -->
    <div class="local-hero">
      <h1 class="local-hero-header">{{ organizationDetails.programName }}</h1>
      <h2 class="local-hero-subtitle">Admin Home</h2>
    </div>

    <div class="form-container">
      <template v-if="loading">
        <LoadSpinner />
      </template>
      <template v-else>
        <div v-if="showSuccessMessage" class="card-shape status-message success-message">
          <div class="success-circle-check-icon">
            <img src="@/assets/icons/success-circle-check-icon.png" />
          </div>
          <div>
            <h4 v-translate>Nomination Submitted</h4>
            <p v-translate>
              The nomination was successful! The recipient will be e-mailed an onboarding link shortly. You may click "Add a Nomination" to add another recipient.
            </p>
          </div>
        </div>

        <button class="form-button wide-button" @click="handleAddNomination">
          Add a Nomination
        </button>
      </template>
    </div>

    <!-- Start Northwestern Nomination modal -->
    <Modal
      v-if="showNorthwesterNominationModal"
      dimmed
      :additionalModalStyles="{
        'max-width': '800px',
        border: 'none',
        padding: 0,
        overflow: 'hidden scroll',
      }"
      :additionalContainerStyles="{
        zIndex: '1001',
        padding: 0,
      }"
      :width="95"
    >
      <div class="form-container card-shape modal-window" style="overflow: hidden;">
        <div class="modal-window-header">
          <h2 class="form-field-header" v-translate>Nominate a Recipient</h2>
          <font-awesome-icon
            class="close-message"
            :icon="['fa', 'times']"
            :style="{ fontSize: '24px', cursor: 'pointer' }"
            @click="handleCloseNominationModal"
          ></font-awesome-icon>
        </div>

        <LoadSpinner v-if="loadingNomination" :color="`#${organizationDetails.darkBrandColor}`" />
        <template v-if="!loadingNomination">
          <SurveyResponseComponent
            :surveyResponse="surveyResponse"
            :cleanSurvey="false"
            :buttonText="$gettext('Add Recipient')"
            @survey-done="handleSurveyDone"
          />
        </template>
      </div>
    </Modal>
    <!-- End Northwestern Nomination modal -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { LoadSpinner } from '@/components'
import SurveyResponseComponent from '@/components/SurveyResponse'
import Modal from '@/components/Modal'

import NominationsApi from '@/services/nominations'
import SurveyResponse from '@/services/surveyresponses'

const SUCCESS = "success"
const FAILURE = "failure"

export default {
  name: 'NorthwesternAdminHome',
  components: {
    LoadSpinner,
    Modal,
    SurveyResponseComponent,
  },
  data() {
    return {
      loading: true,
      loadingNomination: false,
      showNorthwesterNominationModal: false,
      surveyName: 'Northwestern Nomination',
      surveyResponse: null,
      showSuccessMessage: false,
    }
  },
  mounted() {
    this.loading = false
  },
  methods: {
    async handleAddNomination() {
      this.loadingNomination = true
      this.showNorthwesterNominationModal = true

      const surveyResponseId = await NominationsApi.createNorthwesternSurveyResponse()
      this.surveyResponse = await SurveyResponse.api.retrieve(surveyResponseId)

      this.loadingNomination = false
    },
    async handleSurveyDone() {
      try {
        await NominationsApi.createNorthwesternNomination(this.surveyResponse)
        this.showSuccessMessage = true
        setTimeout(this.clearMessage, 3000)
      } catch (e) {
        // Do nothing
      }
      
      this.surveyResponse = null
      this.showNorthwesterNominationModal = false
    },
    handleCloseNominationModal() {
      this.surveyResponse = null
      this.showNorthwesterNominationModal = false
    },
    clearMessage() {
      this.showSuccessMessage = false
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/responsive';

.northwestern {
  .form-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .card-shape {
    padding: 2.5rem 1.5rem;
  }

  .status-message {
    display: flex;
    margin-bottom: 1rem;
    width: 80%;

    &.success-message {
      flex-direction: row;
      background-color: #d2f7dc;
    }

    &.failure-message {
      flex-direction: row;
      background-color: #f0d1d4;
    }

    .success-circle-check-icon, .failure-circle-x-icon {
      width: 20px;
      margin-right: 1rem;
      margin-top: 6px;
    }
  }

  .modal-window {
    margin-top: 4rem;
    padding: 2rem 3rem;
  }

  .modal-window-header {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 2rem;
  }

  .form-button {
    border: 2px solid transparent;
  }

  .form-button:hover {
    border: 2px solid var(--light-brand-color);
  }

  .wide-button {
    padding: 2rem;
    width: 80%;
  }
}
</style>
